<script>

import config from '@/common/genericPanelConf';
import GenericDataTable from '@/components/generic/GenericDataTable.vue';
import ResponsiveButton from '@/components/generic/ResponsiveButton.vue';
import GenericCustomAutocompleteV2 from '@/components/generic/GenericCustomAutocompleteV2.vue';
import Service from '@/services/planning'
import CommonConstants from '../../common/Constants';
import Utils from '@/common/Utils';

export default {
    components: {
        GenericDataTable,
        ResponsiveButton,
        GenericCustomAutocompleteV2
    },
    data(){
        return{
            configuration: null,
            showAddDialog: false,
            addItems: {}
        }
    },
    created(){
        this.configuration = config.getConfiguration("DealNotePriceWindow");
        if(this.configuration){
            this.$store.dispatch('security/setNavbarTitle', this.configuration.title);
        }
    },
    computed: {
        constants() {
            return CommonConstants; 
        },
        utils() {
            return Utils;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        }
    },
    mounted(){
        
    },
    methods: {
        onPriceWindowEdit(data){
            this.$store.dispatch("generic/setLoading", true);
            Service.updateDealNotePriceWindow(data, (response) => {
                this.$store.dispatch("generic/setLoading", false);
                if (response.success) {
                    this.load();
                    this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },
        load(){
            let filters = [];
            this.$refs.dealNotePriceWindow.filterFromView(filters);
        },
        getFields(){
            let fields = [];

            for(let i = 0; i < this.configuration.columns.length; i++){
                let item = this.configuration.columns[i];

                if(item != null && !item.formHide){
                    fields.push(item);
                }
            }
            return fields;
        },
        dialogAddSave(){
            this.$store.dispatch("generic/setLoading", true);
            Service.addDealNotePriceWindow(this.addItems, (response) => {
                this.$store.dispatch("generic/setLoading", false);
                if (response.success) {
                    this.load();
                    this.showAddDialog = false;
                    this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000 });
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        }
    }
}
</script>

<template>
    <Dialog v-model:visible="showAddDialog" :style="{width: '85vw'}" modal>     
        <div class="grid">
            <div class="col-12 lg:col-3" v-for="field in getFields()" :key="field.name">
                <label :for="field.name">{{$t(field.label)}}</label>
                <InputText  
                    class="w-full"                        
                    v-if="field.type == 'string' && !field.formHide" 
                    v-model="addItems[field.name]" />
                <InputText                       
                    class="w-full" 
                    type="number" 
                    v-if="field.type == 'number'"
                    v-model="addItems[field.name]" />
                <InputNumber   
                    class="w-full"                      
                    mode="decimal" :maxFractionDigits="field.digits"
                    v-if="field.type == 'decimal'"
                    v-model="addItems[field.name]" />
                <!--<GenericDateTimeMaskV2 
                    v-if="field.type == 'date'"    
                    v-model="editItem[field.name]"
                    mask="99/99/9999 99:99:99"
                    :unmask="true" />-->
                <Calendar 
                    class="w-full" 
                    v-if="field.type == 'date' && field.name != 'monthDate'"    
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="field.onlyDate ? false : true"
                    :showIcon="true"
                    v-model="addItems[field.name]" /> 
                <Calendar 
                    class="w-full" 
                    v-if="field.type == 'date' && field.name == 'monthDate'"    
                    :placeholder="'mm/yyyy'"
                    name="monthStartDate" dateFormat="mm/yy" :showTime="false"
                    :showIcon="true" :yearNavigator="true"
                    view="month" 
                    v-model="addItems[field.name]" />   
                <GenericCustomAutocompleteV2   
                    class="w-full"                  
                    v-if="field.type == 'select'"
                    :name="field.name"
                    v-model="addItems[field.updateField ?? field.name]" 
                    :api="field.selectApi"                  
                    :format="field.selectFormat" />               
            </div> 
        </div>       
        
        <template #footer>
            <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" @click="dialogAddSave" autofocus />               
        </template>
    </Dialog>
    
    <div class="grid">
        <div class="col-8 lg:col-2 m-3">
            <ResponsiveButton :label="$t('btn.refresh')" icon="pi pi-replay" class="mx-1 p-button-sm" @click="load()"/>
            <ResponsiveButton :label="$t('btn.add')" icon="pi pi-plus" class="mx-1 p-button-sm p-button-success" @click="this.showAddDialog = true" 
            v-if="!uiPermissions('dealNotePriceWindowAddButton').isHidden" />
        </div>
    </div>
    
    <div class="" style="height: 80vh;">
        <GenericDataTable :configuration="configuration" :category="category" :name="name" ref="dealNotePriceWindow" :onDialogEditSave="onPriceWindowEdit" />
    </div>
</template>